import { type AdminProfile, type UserPermissions, type UUID } from "@/core/types";
import { isCseProfile } from "@/core/helpers/(predicates)/adminProfile";
import { isLcsw } from "@/core/helpers/(predicates)/lcsw";

import { LcswPermissionCard } from "./LcswPermissionCard";

type LcswPermissionOthersProps = {
  canGrantLcsw: boolean;
  permissions: Nullable<UserPermissions>;
  profileData: AdminProfile;
  userId: UUID;
};

// other-CSE view: card is visible to any CSE viewer, but only editable when the viewer has
// can_grant_lcsw — otherwise it reflects the target's real status as a read-only switch.
// Permissions/grant-check are fetched by the parent so this stays presentational and covered
// by the page-level loader.
export function LcswPermissionOthers({
  canGrantLcsw,
  permissions,
  profileData,
  userId,
}: LcswPermissionOthersProps) {
  const isCse = isCseProfile(profileData);

  if (!isCse || !permissions) return null;

  return (
    <LcswPermissionCard
      isLcsw={isLcsw(permissions)}
      isReadOnly={!canGrantLcsw}
      userId={userId}
      userName={profileData.name}
    />
  );
}
